<template>
    <div class="prthreads">
        <b-container fluid>
            <b-row>
                <b-col cols="4">
                    <b-row><b-col><SchedaMacchina v-if="!!machine" :m="machine" :info="false" :key="machine.upd" /></b-col></b-row>
                    <!-- <b-row><b-col><Locations v-if="!!machine" :key="machine.upd" /></b-col></b-row> -->
                    <!-- <b-row><b-col><OpenPointsStatus v-if="!!machine" :m="machine" :info="false" :key="machine.upd" /></b-col></b-row> -->
                    <b-row><b-col><OpenPointsMachine v-if="!machine" :info="false" /></b-col></b-row>
                    <b-row><b-col><OpenPointsStatus v-if="!machine" :info="false" /></b-col></b-row>
                    <b-row><b-col><Documents v-if="!!machine" /></b-col></b-row>
                </b-col>
                <b-col>
                    <Threads :m="machine" height="calc(100vh - 455px)"/>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { API } from "@/api.js";
import SchedaMacchina from "@/components/SchedaMacchina.vue";
// import OpenPointsStatus from "@/components/OpenPointsStatus.vue";
import OpenPointsMachine from "@/components/OpenPointsMachine.vue";
// import Locations from "@/components/Locations.vue";
import Threads from "../../components/Threads.vue";
import Documents from "@/components/Documents.vue";

export default {
    name: "PIThreads",
    components: {
        SchedaMacchina,
        // OpenPointsStatus,
        // Locations,
        OpenPointsMachine,
        Threads,
        Documents,
    },
    data: function () {
        return {
            owners: [{ value: "Marsilli", text: "Marsilli" }, { value: "Customer", text: "Customer" }],
        }
    },
    props: {
        
    },
    async mounted(){
        console.log("machine",this.machine)

		this.$nextTick(async () => {
			let k = 1;
            if(this.machine) {
                this.machine.image = "/images/units/" + this.machine.img;
                this.machine.upd = k++;
            }
		});
    },
    computed: {
        section(){
            return this.$store.getters.section
        },
        machine(){
            return this.$store.getters.machine
        },
    },
    methods: {
        addIssue(){
            console.log("addIssue")
            this.formIssue = { no: 0, ts: null, duets: null, line: "", swunit: "", issue: "", owner: "", catid: null, respid: null, phaseid: null, statusid: null, prioritylevel: 1, },
            this.addIssueDlg = true
        },
        async onSubmitIssue(){
            this.formIssue.unit = this.machine.codice
            console.log("onSubmitIssue",this.formIssue)
            await API.addIssue(this.formIssue,this.section)
            // this.gridApi.redrawRows()
            this.issues = await API.prinIssues(this.machine.codice, this.section)
            this.issues = this.issues.map((i,idx) => ({...i, no: idx+1, ts: new Date(i.ts), duets: new Date(i.duets)}))
            this.addIssueDlg = false
            this.$store.commit("incPStates",null);
        },
        onResetIssue(){
            console.log("onResetIssue")
            this.addIssueDlg = false
        },
        dateFormatter(params) {
            return params.value.toLocaleDateString();
        },
    }
}

</script>
<style>
div.prthreads div.card {
    margin: 0px !important;
}
</style>
<style scoped>
div.prthreads {
    padding: 10px;
    padding-top: 60px;
    background-color: #d3d3d3;
}
div.prthreads button {
	background-color: #9a240d !important;
	border-color: #9a240d !important;
	margin-bottom: 10px;
}
div.prthreads button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.prthreads button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.title {
    /* text-align: left; */
    font-weight: 700;
    background-color: white;
}
</style>
